import { render, staticRenderFns } from "./AdminArchivedProjects.vue?vue&type=template&id=18e36d4b&scoped=true&"
import script from "./AdminArchivedProjects.vue?vue&type=script&lang=js&"
export * from "./AdminArchivedProjects.vue?vue&type=script&lang=js&"
import style0 from "./AdminArchivedProjects.vue?vue&type=style&index=0&id=18e36d4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e36d4b",
  null
  
)

export default component.exports